<template>
    <div class="py-4 px-5" style="width: 100%;">
        <div>
            <hb-header full>
                <hb-page-header
                    title="Gate Activity Log"
                    description="View tenants gate activity for a property"
                >
                </hb-page-header>
            </hb-header>
        </div>
        
        <HbPropertySelector
            id="facility"
            :items="facilityList"
            item-text="name"
            item-value="id"
            v-validate="'required'"
            v-model="propertyId"
        />
        <hb-empty-state v-if="!propertyId"
            message="Please select a Property to continue." :showBtn="false">
        </hb-empty-state>
        <div v-else>
            <GateActivityLog
                :property-id="propertyId"
                :initial-limit="1000"
            />
        </div>
    </div>
</template>


<script type="text/babel">

import { notificationMixin } from  '../../mixins/notificationMixin.js';
import { mapGetters } from "vuex";
import GateActivityLog from '../gate-activity-log/GateActivityLog.vue';

export default{
        name: "FacilityActivityLog",
        mixins: [ notificationMixin ],
        data(){
            return {
                propertyId: "",
                logSearch: ""
            }
        },
        props: {

        },
        components:{
            GateActivityLog
        },
        mounted(){

        },
        destroyed(){

        },
        computed:{
            ...mapGetters({
                facilityList: "propertiesStore/filtered"
            }),
        },
        methods:{

        },
        watch:{

        }
}


</script>
